import "./style.css";

import { useState } from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { Carousel } from "antd";
// global components
import { TranslationText } from "components/TextTranslationContainer";
import PreviewMediaUrls from "components/brandHeader/PreviewMediaUrls";
import SlideInLayout from "components/layouts/SlideInLayout";
import { Spinner } from "components";
//constants
import C from "Constants";
import { useWindowDimensions ,useCustomHistory} from "hooks";

const ItemDetailModal = ({
  open,
  handleClose = () => {},
  handleSpecialNoteChange = () => {},
  currentLang,
  selectedItem,
  isLoading,
  specialNote,
  children,
  footerComponent,
  hideOutsideCloseButton=false,
  error,
  isDineIn,
  params
}) => {
  const router = useCustomHistory();

  const sourceUrl =
    selectedItem?.itemInfo?.itemImageURLs?.[0] ?? C.PLACEHODERIMAGE;

  const { width } = useWindowDimensions();
  let currentWidth = width >= 460 ? 458 : width;
  const [hover, setHover] = useState(false);
  const { areaModal, storeModal } = useSelector((state) => state.NotPersist);
  const isCloseButtonDisabled = isDineIn? false:areaModal || storeModal;

  const isDisbaleOutsideClick = ()=>{
    if(hideOutsideCloseButton) return true;
    return isDineIn? false:areaModal || storeModal;
  }

  const { DomainType } = useSelector((state) => state.AppReducer);

  const brandItemImage = (val, index, url, q = "") => {
    let state = {
      urls: selectedItem?.itemInfo?.itemImageURLs,
      val,
      index,
    };
    router(url, `/${params.domainName}${url}`, DomainType, state, isDineIn ? params : "" );
  };

  return (
    <>
    <SlideInLayout
      open={open}
      handleClose={() => handleClose()}
      hideOutsideCloseButton={isCloseButtonDisabled}
      container={{
        className: `item-detail-modal`,
      }}
      scrollY={window.scrollY}
      showBar={false}
      disableOutsideClick={isDisbaleOutsideClick()}
    >
      {!isLoading && (error && !selectedItem) ? (
        <div className="w-full h-full p-4 flex justify-center items-center">
          <TranslationText
            className="text-red-500 text-center font-bold"
          text={
              error?.message && typeof error?.message === "string"
                ? error?.message
                : "We apologize, but the restaurant owner has removed this item from the menu. Please Close this window and try again."
            }
          />
        </div>
      ) : (
        <div className="w-full h-full flex flex-col pt-4">
          <div className="media-container-wrapper">
            <div
              className="absolute left-0 flex justify-center items-center w-full top-0 z-10 -translate-y-1/2"
              onMouseOver={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <Carousel
                style={{ height: (currentWidth - 100) + "px" }}
                className="absolute left-0 flex justify-center items-center w-full top-0 z-10 -translate-y-1/2"
                autoplay={
                  selectedItem?.itemInfo?.itemImageURLs?.length > 1 && !hover
                }
              >
                  {
                    !isLoading && selectedItem?.itemInfo?.itemImageURLs?.length >= 1 ?
                      selectedItem?.itemInfo?.itemImageURLs?.map((item, index) => (
                        <PreviewMediaUrls
                          key={index}
                          containerStyleProps={{
                            className:
                              "flex justify-center items-center w-full media-container cursor-pointer",
                          }}
                          sourceUrl={item}
                          imageProps={{
                            style: { objectFit: "cover" },
                            className: "media-content",
                          }}
                          videoProps={{
                            style: { objectFit: "cover" },
                            className: "media-content",
                          }}
                          showVideoAmbientEffect={false}
                          showImageAmbientEffect={false}
                          onClick={()=> brandItemImage(item, index, "/preview/item-image")}
                        />
                      ))
                      : <PreviewMediaUrls
                        containerStyleProps={{
                          className:
                            "flex justify-center items-center w-full media-container",
                        }}
                        sourceUrl={isLoading ? C.PLACEHODERIMAGE : sourceUrl}
                        imageProps={{
                          style: { objectFit: "cover" },
                          className: "media-content",
                        }}
                        videoProps={{
                          style: { objectFit: "cover" },
                          className: "media-content",
                        }}
                        showVideoAmbientEffect={false}
                        showImageAmbientEffect={false}
                      />}
              </Carousel>
            </div>
          </div>

          <div className="flex-1 content-container overflow-auto px-5">
            {isLoading ? (
              <>
                <Spinner/>
                {/* <Skeleton active />
                <Skeleton active />
                <div className="absolute bottom-0 left-0 right-0 px-4">
                  <Skeleton.Button active size={"large"} block />
                </div> */}
              </>
            ) : (
              <>
                <h2 className="text-dark-blue-900 text-24x font-bold ">
                  {t(selectedItem?.itemInfo?.baseLanguage?.title)}
                </h2>
                {/* <div className="text-brand-base-primary flex items-center gap-2 mt-2 text-13x"><Recommend /> <span>{t("50+ recommend")}</span></div> */}
                <p className="text-14x mt-4 text-dark-blue-700">
                  {t(selectedItem?.itemInfo?.baseLanguage?.description)}
                </p>
                {children}
                {/* <SpecialNote value={specialNote ?? ""} onChange={handleSpecialNoteChange} /> */}
              </>
            )}
          </div>
          {footerComponent}
        </div>
      )}
    </SlideInLayout>
    </>
  );
};

export default ItemDetailModal;
